__turbopack_context__.v({
  "className": "urbanist_8b856726-module__sB_KIG__className",
  "variable": "urbanist_8b856726-module__sB_KIG__variable",
});
